import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d7fe93b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6d7fe93b&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7fe93b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderDefault: require('/home/smiley/3df/components/Header/HeaderDefault/HeaderDefault.vue').default,BlockContent: require('/home/smiley/3df/components/Block/BlockContent/BlockContent.vue').default,CardBig: require('/home/smiley/3df/components/Card/CardBig/CardBig.vue').default,CardSmall: require('/home/smiley/3df/components/Card/CardSmall/CardSmall.vue').default,BannerSeal: require('/home/smiley/3df/components/Banner/BannerSeal/BannerSeal.vue').default,AcademySectionRegister: require('/home/smiley/3df/components/AcademySectionRegister/AcademySectionRegister.vue').default})
